import { render, staticRenderFns } from "./DataManager.vue?vue&type=template&id=3180188b&"
import script from "./DataManager.vue?vue&type=script&lang=js&"
export * from "./DataManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports